'use strict';
var bfBind = { data: '=' };
var DetailDrgCheckDecisionController = (function () {
    function DetailDrgCheckDecisionController(topic) {
        this.topic = topic;
        this.comp = 'goe_data';
        this.lock = true;
        this.completeSection = 'goePick';
        this.goeResultStatusMap = {
            n: 'No',
            u: 'Unknown',
            y: 'Yes'
        };
        this.goeResultStatus = (angular.isDefined(this.data) && !this.data.isError)
            ? this.goeResultStatusMap[this.data.data.goeResult.finalGoeResult.toLowerCase()]
            : "Undetermined";
    }
    DetailDrgCheckDecisionController.$inject = ['topic'];
    return DetailDrgCheckDecisionController;
}());
var DetailDrgCheckDecisionComponent = (function () {
    function DetailDrgCheckDecisionComponent() {
        this.templateUrl = 'detail-drgcheck-decision.html';
        this.controllerAs = 'vm';
        this.controller = DetailDrgCheckDecisionController;
        this.bindings = bfBind;
    }
    return DetailDrgCheckDecisionComponent;
}());
angular
    .module('application')
    .component('drgCheckDecisionSection', new DetailDrgCheckDecisionComponent());

//# sourceMappingURL=detail.drgcheck.decision.component.js.map
